import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { AccountComponent } from './components/account/account.component';
import { ReportComponent } from './components/report/report.component';
import { GuestOnlyGuard } from 'src/app/core/guards/guest-only.guard';
import { AuthorizedOnlyGuard } from 'src/app/core/guards/authorized-only.guard';
import { MessageComponent } from './components/message/message.component';
import { DomainGuard } from './guards/domain.guard';
import { PermissionsGuard } from './guards/permissions.guard';

const routes: Routes = [{
  path: 'login',
  component: LoginComponent,
  canActivate: [GuestOnlyGuard]
}, {
  path: '',
  component: AccountComponent,
  canActivate: [AuthorizedOnlyGuard],
  children: [{
    path: '',
    component: ReportComponent,
    canActivate: [
      PermissionsGuard,
      DomainGuard
    ]
  }, {
    path: 'message',
    component: MessageComponent
  }]
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
